import React from "react";
import heroImage from "../../assets/images/Herosection/herobanner.jpg";

const HeroSection = () => {
  const brandGold = "#C8A27C"; 

  return (
    <section className="relative min-h-screen flex items-center bg-[#0a0a0a] text-white overflow-hidden">
      {/* Background with Motion Effect */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroImage}
          alt="Law Expertise"
          className="w-full h-full object-cover brightness-[0.35] scale-110 animate-slow-pan"
        />
        {/* Layered Overlays */}
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/60 to-transparent"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_50%,rgba(200,162,124,0.15)_0%,transparent_50%)]"></div>
      </div>

      {/* Classical Sidebar (Left) */}
      <div className="hidden lg:flex absolute left-0 top-0 bottom-0 w-24 flex-col items-center justify-center z-20 border-r border-white/10">
        <div className="w-[1px] h-32 bg-gradient-to-b from-transparent via-[#C8A27C] to-transparent mb-6"></div>
        
        {/* Decorative Legal Pillar Icon */}
        <div className="mb-6 text-[#C8A27C] opacity-60">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M4 21h16M4 18h16M6 18v-9M10 18v-9M14 18v-9M18 18v-9M5 9c0-2 2-4 7-4s7 2 7 4" />
          </svg>
        </div>

        <p className="rotate-180 [writing-mode:vertical-lr] text-[12px] tracking-[0.6em] uppercase text-[#C8A27C] font-bold">
          Adv. Saurav Dagar
        </p>
        <div className="w-[1px] h-32 bg-gradient-to-t from-transparent via-[#C8A27C] to-transparent mt-10"></div>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:pl-40 py-20 pt-40">
        <div className="max-w-4xl">
          {/* Top Badge */}
          <div className="inline-flex items-center gap-3 mb-8 bg-white/5 border border-white/10 px-4 py-2  rounded-full">
            <span className="w-2 h-2 rounded-full bg-[#C8A27C] animate-pulse"></span>
            <span className="text-[#C8A27C] uppercase tracking-[0.3em] text-[11px] font-bold ">
              Premier Legal Representation in Ghaziabad
            </span>
          </div>

          {/* Headline */}
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif font-bold leading-[1.05] mb-10 tracking-tight">
            <span className="block text-white/90 text-[0.8em]">Commitment to</span>
            <span 
              className="italic font-normal block" 
              style={{ color: brandGold }}
            >
              Excellence & Justice
            </span>
          </h1>

          {/* Description */}
          <div className="relative mb-12">
            <div className="absolute left-0 top-0 bottom-0 w-[2px] bg-[#C8A27C]/50"></div>
            <p className="text-gray-300 text-lg md:text-xl leading-relaxed pl-8 italic font-light max-w-2xl">
              Adv. Saurav Dagar is a trusted legal expert specializing in Civil, Criminal, 
              Matrimonial, and Court Marriage cases, delivering dedicated advocacy 
              across the Uttar Pradesh region.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-6">
            <a
              href="/contact-us"
              className="relative px-12 py-5 bg-[#C8A27C] text-black font-black uppercase tracking-[0.2em] text-xs transition-all hover:bg-white overflow-hidden group shadow-xl shadow-[#C8A27C]/10"
            >
              <span className="relative z-10">Schedule Consultation</span>
              <div className="absolute inset-0 translate-y-full group-hover:translate-y-0 bg-white transition-transform duration-500 ease-out"></div>
            </a>

            <a
              href="/services"
              className="px-12 py-5 border border-white/20 text-white font-black uppercase tracking-[0.2em] text-xs hover:border-[#C8A27C] hover:text-[#C8A27C] transition-all backdrop-blur-md hover:bg-white/5"
            >
              Practice Areas
            </a>
          </div>
        </div>
      </div>

      {/* Decorative Justice Watermark */}
      <div className="absolute bottom-[-2%] right-[-2%] text-[22vw] font-black text-white/[0.02] leading-none select-none pointer-events-none uppercase italic tracking-tighter animate-subtle-float">
        Justice
      </div>

      {/* Custom Styles for Animations */}
      <style jsx>{`
        @keyframes slow-pan {
          0% { transform: scale(1.1) translateX(0); }
          50% { transform: scale(1.15) translateX(-1%); }
          100% { transform: scale(1.1) translateX(0); }
        }
        @keyframes subtle-float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-20px); }
        }
        .animate-slow-pan {
          animation: slow-pan 20s ease-in-out infinite;
        }
        .animate-subtle-float {
          animation: subtle-float 10s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
};

export default HeroSection;